const API_ENDPOINTS = {
  GENERATE_SSO_URL:'/accounts/v2/generatessourl',
  SSO_LOGIN: "/accounts/login",
  LOGIN_PATCH: "/accounts/users/",
  QUICK_QUOTE: "/group/quotation",
  CREATE_QUOTE: "/group/policy",
  PAYMENT: "/group/payment",
  HEALTH_LISTING: "/group/health-listing",
  HEALTH_PAYMENT_STATUS: "/group/health-payment-status",
  HEALTH_DRAFT_EMAIL: "/group/health-draft-email",
  VALIDATE_PHONE_NUMBER: "/group/validate-phone-number",
  GET_PINCODE: "/autofill/pincode",
  CREATE_LEAD: "/create-lead",
  UPDATE_LEAD: "/update-lead",
  LEAD_DASHBOARDS:"/leads/dashboard"
};


export { API_ENDPOINTS }